/**
 * Validates a `?next=` redirect target so login can't be used as an open
 * redirect. WHATWG URL parsing treats "\" like "/" for special schemes, so
 * "/\evil.com" (and "//evil.com") resolve to a different origin — resolving
 * against `origin` and comparing origins (plus rejecting backslashes
 * outright) catches both, along with absolute URLs and non-http schemes.
 */
export function safeNextPath(next: string | null, origin: string): string {
  const fallback = "/";
  if (!next || !next.startsWith("/") || next.includes("\\")) return fallback;
  try {
    return new URL(next, origin).origin === origin ? next : fallback;
  } catch {
    return fallback;
  }
}
